module.exports = __webpack_public_path__ + "img/interactive.a97ebc2d.svg";